import React from "react";
import { FaTrash } from "react-icons/fa";
import { encryptId } from "../utils/encrypt";

const TableWithPaginationComponent = ({
  materials = [],
  pagination = {},
  onPageChange = () => {},
  listClickHandler,
  onDelete = () => {},
}) => {
  const { page, totalPages } = pagination;

  const goToMaterialDetailPage = (id) => {
    listClickHandler(`${encodeURIComponent(encryptId(id))}`);
  };

  return (
    <div className="mt-2 px-6">
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 text-sm text-left">
          <thead className="bg-gray-100 text-gray-700 uppercase sticky top-0 z-10">
            <tr>
              <th className="px-4 py-2 border-b">Raw Material Name</th>
              <th className="px-4 py-2 border-b">Material Code</th>
              <th className="px-4 py-2 border-b">Price</th>
              <th className="px-4 py-2 border-b">Company Name</th>
              <th className="px-4 py-2 border-b">Density</th>
              <th className="px-4 py-2 border-b">Chemical Type</th>
              <th className="px-4 py-2 border-b">Delete</th>
            </tr>
          </thead>
          <tbody>
            {materials?.map((item) => {
              const {
                _id,
                chemicalName,
                chemicalCode,
                density,
                basePrice,
                chemicalType,
                companyName,
              } = item;
              return (
                <tr
                  key={_id}
                  onClick={() => goToMaterialDetailPage(_id)}
                  className="hover:bg-gray-50 cursor-pointer"
                >
                  <td className="px-4 py-2 border-b font-semibold">{chemicalName}</td>
                  <td className="px-4 py-2 border-b font-semibold">{chemicalCode}</td>
                  <td className="px-4 py-2 border-b">{`${basePrice}/kg`}</td>
                  <td className="px-4 py-2 border-b">{companyName}</td>
                  <td className="px-4 py-2 border-b">{density}</td>
                  <td className="px-4 py-2 border-b">{chemicalType}</td>
                  <td className="px-4 py-2 border-b">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(_id);
                      }}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-center mt-4 gap-2">
        <button
          className="px-3 py-1 text-sm rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
        >
          «
        </button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i}
            className={`px-3 py-1 text-sm rounded ${
              page === i + 1
                ? "bg-pink-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
            onClick={() => onPageChange(i + 1)}
          >
            {i + 1}
          </button>
        ))}
        <button
          className="px-3 py-1 text-sm rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
        >
          »
        </button>
      </div>
    </div>
  );
};

export default TableWithPaginationComponent;
